import type { JSX } from "react";
import { Navigate } from "react-router";

import { defaultSettingsPath } from "@/lib/navigation";
import { useSession } from "@/lib/supabase";

/** `/settings` index — land on the first tab visible for the current role. */
export function SettingsIndexRedirect(): JSX.Element {
  const session = useSession();
  if (session.status === "loading") {
    return (
      <output aria-live="polite" className="text-body-2 text-muted-foreground">
        Cargando…
      </output>
    );
  }
  if (session.status === "anonymous") {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={defaultSettingsPath(session.role)} replace />;
}
